import React, { useState ,useEffect,useRef} from 'react';
import { X } from 'lucide-react';
import './internshippage.css';
import Loading1 from '../loading_animation/loading';
import { useNavigate } from "react-router-dom";

const InternshipPage = () => {

  const [message, setMessage] = useState(null);
   const [step, setStep] = useState(1);
   const [branches, setBranches] = useState([]);
  const [domains, setDomains] = useState([]);
  const navigate = useNavigate();
  const [hoverStates, setHoverStates] = useState({
    image1: false,
    image2: false
  });
   const [isLoading, setIsLoading] = useState(false);
   const[config,setConfig]=useState(null);
   const[IsLoggedIn,setIsLoggedIn]=useState(false);
    const [errors, setErrors] = useState({});
    const [posterUrl, setPosterUrl] = useState(null);
    const [hasApplied, setHasApplied] = useState(false);
    const[mode,setMode]=useState(false);
    const [customText, setCustomText] = useState("");

const fieldRefs = {
    name: useRef(null),
    email: useRef(null),
    phone: useRef(null),
    address: useRef(null),
    profile_image: useRef(null),
    aadhar: useRef(null),
    aadhar_front: useRef(null),
    aadhar_back: useRef(null),
    schoolName: useRef(null),
    schoolPercentage: useRef(null),
    intermediateName: useRef(null),
    intermediatePercentage: useRef(null),
    college: useRef(null),
    branch: useRef(null),
    cgpa: useRef(null),
    college_id: useRef(null),
  };

    useEffect(() => {
      fetch("/config.json")
        .then(res => res.json())
        .then(data => setConfig(data))
        .catch(err => console.error("Failed to load config.json", err));
    }, []);

  useEffect(() => {
      if (!config) return; 
      const checkSession = async () => {
        try {
          const res = await fetch(`${config.BASE_URL}${config.CHECK_SESSION}`, {
             method: "POST",
            credentials: "include",
          });
          const data = await res.json();
          setIsLoggedIn(data.active);
        } catch (err) {
          setIsLoggedIn(false);
        }
      };
      checkSession();
    }, [config]);


    useEffect(() => {
  if (!config) return;

  const checkApplication = async () => {
    try {
      const res = await fetch(`${config.BASE_URL}${config.CHECK_APPLICATION_STATUS}`, {
        method: "POST",
        credentials: "include",
      });

      const data = await res.json();

      if (data.success) {
        setHasApplied(true);
      } else {
        setHasApplied(false);
      }
    } catch (e) {
      console.error("Error checking status:", e);
    }
  };

  checkApplication();
}, [config]);

//console.log(hasApplied);

useEffect(() => {
  if (!config) return;

  const fetchPoster = async () => {
    try {
      const res = await fetch(`${config.BASE_URL}${config.GET_INTERNSHIP_POSTER}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({})
      });
      const data = await res.json();
      if (data.success && data.posterName) {
        setPosterUrl(`/Poster/${data.posterName}`); 
        setCustomText(data.customText || "");
      } else {
        console.error("Failed to fetch poster:", data.message);
      }
    } catch (err) {
      console.error("Error fetching poster:", err);
    }
  };

  fetchPoster();
}, [config]);




 useEffect(() => {
  const fetchBranches = async () => {
    try {
      const res = await fetch('/data.json'); 
      const data = await res.json();
      setBranches(data.branches || []);
    } catch (err) {
      console.error("Failed to load branches JSON:", err);
    }
  };

  const fetchDomains = async () => {
    try {
      // Load config.json first
      const configRes = await fetch('/config.json');
      const config = await configRes.json();

      const res = await fetch(`${config.BASE_URL}${config.GET_INTERNSHIP_DOMAINS}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" }
      });

      const data = await res.json();
      if (data.success && Array.isArray(data.domains)) {
        setDomains(data.domains);
      } else {
        console.error("Failed to fetch domains:", data.message);
      }
    } catch (err) {
      console.error("Failed to load domains:", err);
    }
  };

  fetchBranches();
  fetchDomains();
}, []);

const scrollToFirstError = () => {
  const firstErrorKey = Object.keys(errors).find((key) => errors[key]);
  if (firstErrorKey && fieldRefs[firstErrorKey]?.current) {
    fieldRefs[firstErrorKey].current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    fieldRefs[firstErrorKey].current.focus();
  }
};

  const initialFormData = {
  name: '',
  email: '',
  phone: '',
  address: '',
  profile_image: null,
  aadhar: '',
  aadhar_front: null,
  aadhar_back: null,
  schoolName: '',
  schoolPercentage: '',
  intermediateName: '',
  intermediatePercentage: '',
  college: '',
  branch: '',
  cgpa: '',
  college_id: null,
  domain: '',
  skills: '',
  duration: '',
  resume: null,
  mode:''
};

const [formData, setFormData] = useState(initialFormData);


  const images = {
    image1: {
      main: 'intern3.jpg', 
      hover: 'intern2.jpg' 
    },
    image2: {
      main: 'intern4.jpg', 
      hover: 'intern1.jpg' 
    }
  };

  const validators = {
    name: (val) => {
  if (!val.trim()) {
    return "Name is required";
  } else if (!/^[A-Za-z\s]+$/.test(val)) {
    return "Name should only contain letters";
  }
  return "";
},

    email: (val) =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) ? '' : 'Invalid email format',
    phone: (val) =>
      /^\d{10}$/.test(val) ? '' : 'Phone number must be 10 digits',
    address: (val) => val.trim() ? '' : 'Address is required',
    profile_image: (file) =>
      file && ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
        ? ''
        : 'Profile image must be jpg/png',
    aadhar: (val) =>
      /^\d{12}$/.test(val) ? '' : 'Aadhar must be 12 digits',
    aadhar_front: (file) =>
      file && ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
        ? ''
        : 'Aadhar front image required (jpg/png)',
    aadhar_back: (file) =>
      file && ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
        ? ''
        : 'Aadhar back image required (jpg/png)',
    schoolName: (val) => val.trim() ? '' : 'School name required',
    schoolPercentage: (val) =>
      val && val >= 0 && val <= 100 ? '' : 'Enter valid percentage',
    intermediateName: (val) => val.trim() ? '' : 'Intermediate name required',
    intermediatePercentage: (val) =>
      val && val >= 0 && val <= 100 ? '' : 'Enter valid percentage',
    college: (val) => val.trim() ? '' : 'College name required',
    branch: (val) => val ? '' : 'Branch required',
    cgpa: (val) => val && val >= 0 && val <= 10 ? '' : 'Enter valid CGPA',
    college_id: (file) => file ? '' : 'College ID proof required',
    domain: (val) => val ? '' : 'Domain required',
    skills: (val) => val.trim() ? '' : 'Skills required',
    duration: (val) => val ? '' : 'Duration required',
    resume: (file) => file ? '' : 'Resume required',
  };

  const validateField = (name, value) => {
    const error = validators[name] ? validators[name](value) : '';
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error === '';
  };


  const isStepValid = (currentStep) => {
  if (currentStep === 1) {
    return (
      formData.name &&
      formData.email &&
      formData.phone &&
      formData.address &&
      formData.profile_image &&
      formData.aadhar &&
      formData.aadhar_front &&
      formData.aadhar_back &&
      Object.keys(errors).every((key) => !errors[key])
    );
  } else if (currentStep === 2) {
    return (
      formData.schoolName &&
      formData.schoolPercentage &&
      formData.intermediateName &&
      formData.intermediatePercentage &&
      formData.college &&
      formData.branch &&
      formData.cgpa &&
      formData.college_id &&
      Object.keys(errors).every((key) => !errors[key])
    );
  }
  return true; 
};


   const handleChange = (e) => {
    const { name, value, files } = e.target;
    const fieldValue = files ? files[0] : value;

    setFormData({ ...formData, [name]: fieldValue });

    // Real-time validation
    validateField(name, fieldValue);
  };


   const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields before submitting
    let allValid = true;
    Object.keys(formData).forEach((field) => {
      const isValid = validateField(field, formData[field]);
      if (!isValid) allValid = false;
    });

    if (!allValid) {
      setMessage('Please correct errors before submitting.');
      return;
    }

    setIsLoading(true);
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    try {
      const response = await fetch('/config.json');
      const config = await response.json();

      const res = await fetch(`${config.BASE_URL}${config.SUBMIT_INTERNSHIP}`, {
        method: "POST",
        credentials: "include",
        body: formDataToSend
      });

      const data = await res.json();

      if (data.status) {
        setMessage("Internship application submitted successfully!");
        setFormData(initialFormData);
        setStep(1);
        setErrors({});
      } else {
        setMessage("Error: " + data.message);
      }
    } catch (err) {
      console.error(err);
      setMessage("Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

     useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);


  return (
    <div className="internship-page">
            {message && (
              <div
                style={{
                  position: "fixed",
                  top: "50px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "15px 20px",
                  borderRadius: "12px",
                  background: "rgba(255,255,255,0.15)",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                  color: "black",
                  fontSize: "14px",
                  fontWeight: "500",
                  zIndex: 1000,
                  minWidth: "250px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <span>{message}</span>
                <X
                  size={18}
                  style={{ marginLeft: "15px", cursor: "pointer" }}
                  onClick={() => setMessage(null)}
                />
              </div>
            )}

            {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <Loading1 />
        </div>
      )}
      <h1 className="page-title">Internship Programs</h1>
      
      {/* Image Hover Section */}
      <div className="image-grid">
        {/* STI Program */}
        <div 
          className="image-container"
          onMouseEnter={() => setHoverStates({...hoverStates, image1: true})}
          onMouseLeave={() => setHoverStates({...hoverStates, image1: false})}
        >
          <div className="image-wrapper glass-card">
            <img 
              src={images.image1.main} 
              alt="Short Term Internship"
              className={`main-image ${hoverStates.image1 ? 'fade-out' : 'fade-in'}`}
            />
            <img 
              src={images.image1.hover} 
              alt="STI Program Details"
              className={`hover-image ${hoverStates.image1 ? 'fade-in' : 'fade-out'}`}
            />
            <div className={`info-overlay ${hoverStates.image1 ? 'visible' : ''}`}>
              <h3>2-Month Program</h3>
              <p>20 Days Training + 40 Days Project</p>
            </div>
          </div>
        </div>

        {/* LTI Program */}
        <div 
          className="image-container"
          onMouseEnter={() => setHoverStates({...hoverStates, image2: true})}
          onMouseLeave={() => setHoverStates({...hoverStates, image2: false})}
        >
          <div className="image-wrapper glass-card">
            <img 
              src={images.image2.main} 
              alt="Long Term Internship"
              className={`main-image ${hoverStates.image2 ? 'fade-out' : 'fade-in'}`}
            />
            <img 
              src={images.image2.hover} 
              alt="LTI Program Details"
              className={`hover-image ${hoverStates.image2 ? 'fade-in' : 'fade-out'}`}
            />
            <div className={`info-overlay ${hoverStates.image2 ? 'visible' : ''}`}>
              <h3>4-Month Program</h3>
              <p>40 Days Training + 80 Days Project</p>
            </div>
          </div>
        </div>
      </div>

      {/* Internship Content Section */}
      <div className="content-section glass-card">
        <h2>About Internship</h2>
        <p>
          An internship is a short-term work experience offered by Robocoupler, with the intention to educate and provide entry-level exposure to a particular industry or field with real-time exploration and infinite projects. Ideally, interns spend their time working on relevant projects, learning about the field, making industry connections, and developing both hard and soft skills.
        </p>

        <h3>Why Are Internships Important?</h3>
        <p>
          As an intern, you get a chance to work side by side with accomplished industry professionals and get a pretty good idea of what an entry-level role might entail. You'll not only gain real work experience but also meet and learn from the pros. And you'll start to build your own network, from your fellow interns to seasoned leaders.
        </p>
        <p>
          One other less obvious but equally important benefit of an internship is the chance to figure out what you don't want to do. It's often difficult to know where to even start when it comes to job searching. Internships give you the chance to try a few things out without committing. If you're lucky, you'll find something you love. And if not, you'll at least know what doesn't work for you.
        </p>

        <h3>How Much Time Do Interns Spend in the Company?</h3>
        <p>
          This actually depends on which internship term you select: either 2-Months or 4-Months.
        </p>

        <div className="program-details">
          <div className="program-card glass-card">
            <h4>2-MONTHS SHORT TERM INTERNSHIP (STI)</h4>
            <p>
              This 60-day internship focuses on target-based project development, where students get 20 days of training and 40 days to develop projects with real-time expert support.
            </p>
          </div>

          <div className="program-card glass-card">
            <h4>4-6 MONTHS LONG TERM INTERNSHIP (LTI)</h4>
            <p>
              This 120/180-day internship involves 100% deployment projects for company requirements, where students get 25
              days of training and remaining days to develop projects with real-time expert support, either in model development or software.
            </p>
          </div>
        </div>
      </div>



            {/* Internship Application Form */}
<div className="form-section glass-card">
  <h2>Apply for Internship</h2>
  {posterUrl && customText && (
  <p className="poster-custom-text">{customText}</p>
)}

  {IsLoggedIn? (
    <>
     {hasApplied ? (
        <div className="already-applied-card glass-card">
          <p style={{ fontSize: "18px", marginBottom: "20px", color: "#0a0a0a" }}>
            Your internship application is <strong>under process</strong>.
          </p>

          <button
            className="check-status-btn"
             onClick={() => navigate("/account", { state: { openTab: "internship" } })}
          >
            Check Status
          </button>
        </div>
      ) : (
  <form onSubmit={handleSubmit}>
    {/* Step Navigation */}

    {/* Step 1: Personal Information */}
    {step === 1 && (
      <>
        <div className="form-group">
          <label htmlFor="name">Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            ref={fieldRefs.name}
            placeholder="Enter name..."
            value={formData.name}
            onChange={handleChange}
            required
          />
           {errors.name && <span className="error">{errors.name}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="email">Email *</label>
          <input
            type="email"
            id="email"
            name="email"
            ref={fieldRefs.email}
            placeholder="Enter email..."
            value={formData.email}
            onChange={handleChange}
            required
          />
           {errors.email && <span className="error">{errors.email}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone Number *</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            ref={fieldRefs.phone}
            placeholder="Enter phone number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          {errors.phone && <span className="error">{errors.phone}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="phone">Address *</label>
          <input
            type="text"
            id="address"
            name="address"
            ref={fieldRefs.address}
            placeholder="Enter your present address"
            value={formData.address}
            onChange={handleChange}
            required
          />
           {errors.address && <span className="error">{errors.address}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="profile_image">Upload Profile Image *</label>
          <input
            type="file"
            id="profile_image"
            name="profile_image"
            ref={fieldRefs.profile_image}
            accept="image/*"
            onChange={handleChange}
            required
          />
          {errors.profile_image && <span className="error">{errors.profile_image}</span>}
        </div>

         <div className="form-group">
          <label htmlFor="aadhar">Aadhar Number *</label>
          <input
            type="text"
            id="aadhar"
            name="aadhar"
            ref={fieldRefs.aadhar}
            placeholder="Enter 12-digit Aadhar..."
            value={formData.aadhar}
            onChange={handleChange}
            maxLength="12"
            required
          />
          {errors.aadhar && <span className="error">{errors.aadhar}</span>}
        </div>

        <div className="form-group">
        <label htmlFor="aadhar_front">Upload Aadhar Image Front*</label>
        <input
          type="file"
          id="aadhar_front"
          name="aadhar_front"
          ref={fieldRefs.aadhar_front}
          accept="image/*"
          onChange={handleChange}
          required
        />
      </div>

<div className="form-group">
  <label htmlFor="aadhar_back">Upload Aadhar Image Back *</label>
  <input
    type="file"
    id="aadhar_back"
    name="aadhar_back"
    ref={fieldRefs.aadhar_back}
    accept="image/*"
    onChange={handleChange}
    required
  />
</div>

        <div className="form-navigation">
           <button
          type="button"
          className="next-btn"
          onClick={() => {
            if (isStepValid(1)) {
              setStep(2);
            } else {
              scrollToFirstError();
            }
          }}
        >
          Next
        </button>
        </div>
      </>
    )}

    {/* Step 2: Educational Information */}
    {step === 2 && (
      <>
        {/* School Details */}
        <div className="form-group">
          <label htmlFor="schoolName">School Name *</label>
          <input
            type="text"
            id="schoolName"
            name="schoolName"
            ref={fieldRefs.schoolName}
            placeholder="Enter school name..."
            value={formData.schoolName || ""}
            onChange={handleChange}
            required
          />
           {errors.schoolName && <span className="error">{errors.schoolName}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="schoolPercentage">School Percentage *</label>
          <input
            type="number"
            step="0.01"
            id="schoolPercentage"
            name="schoolPercentage"
            ref={fieldRefs.schoolPercentage}
            placeholder="Enter school percentage"
            value={formData.schoolPercentage || ""}
            onChange={handleChange}
            required
          />
           {errors.schoolPercentage && <span className="error">{errors.schoolPercentage}</span>}
        </div>

        {/* Intermediate/Diploma Details */}
        <div className="form-group">
          <label htmlFor="intermediateName">Intermediate/Diploma Name *</label>
          <input
            type="text"
            id="intermediateName"
            name="intermediateName"
            ref={fieldRefs.intermediateName}
            placeholder="Enter intermediate/diploma name..."
            value={formData.intermediateName || ""}
            onChange={handleChange}
            required
          />
           {errors.intermediateName && <span className="error">{errors.intermediateName}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="intermediatePercentage">Intermediate/Diploma Percentage *</label>
          <input
            type="number"
            step="0.01"
            id="intermediatePercentage"
            name="intermediatePercentage"
            ref={fieldRefs.intermediatePercentage}
            placeholder="Enter intermediate/diploma percentage..."
            value={formData.intermediatePercentage || ""}
            onChange={handleChange}
            required
          />
          {errors.intermediatePercentage && <span className="error">{errors.intermediatePercentage}</span>}
        </div>

        {/* College Details */}
        <div className="form-group">
          <label htmlFor="college">College Name *</label>
          <input
            type="text"
            id="college"
            name="college"
            placeholder="Enter college name..."
            ref={fieldRefs.college}
            value={formData.college}
            onChange={handleChange}
            required
          />
          {errors.college && <span className="error">{errors.college}</span>}
        </div>
         <div className="form-group">
  <label htmlFor="branch">Branch *</label>
  <select
    id="branch"
    name="branch"
    value={formData.branch}
    onChange={handleChange}
    required
  >
    <option value="">-SELECT-</option>
    {branches.map((b, idx) => (
      <option key={idx} value={b}>{b}</option>
    ))}
  </select>
   {errors.branch && <span className="error">{errors.branch}</span>}
</div>
        <div className="form-group">
          <label htmlFor="cgpa">CGPA *</label>
          <input
            type="number"
            step="0.01"
            id="cgpa"
            name="cgpa"
            ref={fieldRefs.cgpa}
            placeholder="Enter CGPA..."
            value={formData.cgpa || ""}
            onChange={handleChange}
            required
          />
           {errors.cgpa && <span className="error">{errors.cgpa}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="collegeIdProof">Upload College ID Proof *</label>
          <input
            type="file"
            id="collegeIdProof"
            name="college_id"
            accept="image/*,application/pdf"
            onChange={handleChange}
            required
          />
           {errors.college_id && <span className="error">{errors.college_id}</span>}
        </div>

        <div className="form-navigation">
          <button type="button" className="back-btn" onClick={() => setStep(1)}>
            Back
          </button>
          <button
    type="button"
    className="next-btn"
    onClick={() => {
      if (isStepValid(2)) {
        setStep(3);
      } else {
        scrollToFirstError();
      }
    }}
  >
    Next
  </button>
        </div>
      </>
    )}

    {/*Additional Information */}
    {step === 3 && (
      <>
        <div className="form-group">
  <label htmlFor="domain">Interested Domain *</label>
  <select
    id="domain"
    name="domain"
    value={formData.domain}
    onChange={handleChange}
    required
  >
    <option value="">-SELECT-</option>
    {domains.map((d) => (
      <option key={d.id} value={d.internship_domain_name}>
        {d.internship_domain_name}
      </option>
    ))}
  </select>
</div>

        <div className="form-group">
          <label htmlFor="skills">Skills *</label>
          <textarea
            id="skills"
            name="skills"
            placeholder="Enter your skills (comma separated)"
            value={formData.skills || ""}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="domain">Select Duration *</label>
          <select
            id="duration"
            name="duration"
            value={formData.duration}
            onChange={handleChange}
            required
          >
            <option value="">-SELECT-</option>
            <option value="one month">One Month</option>
            <option value="two months">Two Months</option>
            <option value="four months">Four Months</option>
            <option value="six months">Six Months</option>
          </select>
        </div>

         <div className="form-group">
      <label htmlFor="mode">Mode *</label>
      <select
        id="mode"
        name="mode"
        value={formData.mode}
        onChange={handleChange}
        required
      >
        <option value="">-SELECT-</option>
        <option value="online">Online</option>
        <option value="offline">Offline</option>
      </select>
    </div>
  

        <div className="form-group">
          <label htmlFor="resume">Resume *</label>
          <input
            type="file"
            id="resume"
            name="resume"
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-navigation">
          <button type="button" className="back-btn" onClick={() => setStep(2)}>
            Back
          </button>
          <button type="submit" className="submit-btn glass-card">
            Submit
          </button>
        </div>
      </>
    )}
  </form>
   )}
  </>
  ):(
    <>
    <div className="not-logged-wrapper">
    <div className="not-logged-card">
      <img
        src={posterUrl || "/Poster/main_poster.jpg"}
        alt="Internship Poster"
        className="poster-image"
      />

      <button
        className="login-btn"
        onClick={() => navigate("/login")}
      >
        Login to Apply
      </button>
    </div>
  </div>
    </>
  )}
</div>

 </div>
  );
};

export default InternshipPage;